function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Videos",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large",
  transform: "translate(-737.000000, -2768.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Footer",
  transform: "translate(0.000000, 2559.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-icons",
  transform: "translate(625.000000, 195.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "twitter",
  transform: "translate(100.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Social-/-Twitter",
  transform: "translate(12.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3628,3.23821875 C14.3704,3.37878125 14.3724,3.52015625 14.3724,3.6619375 C14.3724,7.99825 11.0708,13 5.032,13 C3.1776,13 1.4524,12.4564375 0,11.5245 C0.2576,11.555375 0.5184,11.5708125 0.7828,11.5708125 C2.3212,11.5708125 3.7368,11.04675 4.86,10.166 C3.4244,10.1391875 2.2128,9.19059375 1.794,7.88490625 C1.994,7.92390625 2.1992,7.94584375 2.4112,7.94584375 C2.7104,7.94584375 3.0012,7.90440625 3.2752,7.8300625 C1.7744,7.5294375 0.6424,6.20303125 0.6424,4.6125625 C0.6424,4.59875 0.6424,4.58534375 0.6432,4.57071875 C1.0848,4.8173125 1.592,4.96478125 2.1304,4.98184375 C1.248,4.39278125 0.6692,3.38771875 0.6692,2.24940625 C0.6692,1.6485625 0.8324,1.0855 1.1136,0.60125 C2.7316,2.58659375 5.1524,3.89146875 7.8804,4.03040625 C7.8248,3.78828125 7.796,3.5384375 7.796,3.28046875 C7.796,1.4698125 9.2652,0 11.078,0 C12.0232,0 12.874,0.3989375 13.4744,1.03715625 C14.2216,0.8896875 14.9256,0.6150625 15.5592,0.24009375 C15.3128,1.005875 14.7932,1.6485625 14.1156,2.05521875 C14.7788,1.97559375 15.4124,1.79928125 16,1.53846875 C15.5612,2.19578125 15.0044,2.77509375 14.3628,3.23821875",
  id: "twitter"
})))))));

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Social / Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.8156bf75.svg";
export { ForwardRef as ReactComponent };